import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const BottomCommunityIcon: React.FC<IconProps> = ({ width = 24, height = 24, color = 'currentColor' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4H16C17.1046 4 18 4.89543 18 6V12C18 13.1046 17.1046 14 16 14H8L4 18V6C4 4.89543 4.89543 4 6 4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M18 8H19C20.1046 8 21 8.89543 21 10V20L17 16H10C8.89543 16 8 15.1046 8 14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

export default BottomCommunityIcon;
